document.addEventListener('DOMContentLoaded', () => {
  const goNext = (loop) => {
    const active = loop.querySelector('.c-references__gallery-picture--visible');
    const next = active.nextElementSibling || active.parentElement.firstElementChild;
    active.classList.remove('c-references__gallery-picture--visible');
    next.classList.add('c-references__gallery-picture--visible');

    setTimeout(() => {
      goNext(loop);
    }, 3000);
  };

  document.querySelectorAll('.js-loop-fade').forEach((loop) => {
    setTimeout(() => {
      goNext(loop);
    }, 3000);
  });
});
